/**
 * A TINTED piece on screen (lib/decor/tint.ts): the SVG colour matrix the print applies on
 * a canvas, here as a CSS `filter: url(#…)`. Render <TintFilter stops={…}/> next to the
 * image and give the image `tintCss(stops)`. Same id for the same colours: a page with
 * thirty tinted letters defines one filter (duplicates are harmless — same content).
 */
import type { CSSProperties } from 'react';
import { isTint, tintFilterId, tintMatrixValues, type TintStops } from '../../lib/decor/tint';

export function TintFilter({ stops }: { stops?: TintStops | null }) {
  if (!isTint(stops)) return null;
  return (
    <svg aria-hidden width="0" height="0" style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }} data-tint-filter="">
      <filter id={tintFilterId(stops)} colorInterpolationFilters="sRGB" x="0" y="0" width="100%" height="100%">
        <feColorMatrix type="matrix" values={tintMatrixValues(stops)} />
      </filter>
    </svg>
  );
}

/** The image's style for a tint (nothing for an untinted piece). */
export function tintCss(stops?: TintStops | null): CSSProperties {
  return isTint(stops) ? { filter: `url(#${tintFilterId(stops)})` } : {};
}
